// extracted by mini-css-extract-plugin
export default {"ball-pulse-sync":"styles_ball-pulse-sync__n2PLA","section-loader-reload-btn":"styles_section-loader-reload-btn__7bHVl"};